import React from "react";
import { shorthands, tokens, useId, Input } from "@fluentui/react-components";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const InputUnderline = (props) => {
  const {
    placeholder,
    handleChange,
    error,
    value,
    inputUnderlinewd,
    isRequired,
    handleBlur,
    ref,
    loading = false,
    autoFocus = true,
    disabled = false,
    maxLength,
  } = props;
  const underlineId = useId("input-underline");
  const handleChangeValue = (event) => {
    const value = event.target.value;
    handleChange(value);
  };

  return (
    <div className={inputUnderlinewd}>
      {loading ? (
        <Skeleton height={40} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
      ) : (
        <Input
          appearance="underline"
          placeholder={`${placeholder} ${isRequired ? "*" : ""}`}
          id={underlineId}
          onChange={handleChangeValue}
          value={value}
          className="InputUnderline"
          onBlur={handleBlur}
          ref={ref}
          autoFocus={autoFocus}
          disabled={disabled}
          maxLength={maxLength}
        />
      )}

      {error && <p className="InputUnderline_errorMessage">{error}</p>}
    </div>
  );
};

export default InputUnderline;
